interface HighnoteSignatureProps {
	isSidebar?: boolean;
	isSidebarCollapsed?: boolean;
}

const HighnoteSignature = ({ isSidebar, isSidebarCollapsed }: HighnoteSignatureProps) => {
	const LINK = "https://www.highnoteai.com/";
	const sidebarImg = isSidebarCollapsed ? "vertical.svg" : "horizontal.svg";

	if (isSidebar) {
		return (
			<a href={LINK} target="_blank">
				<div className="highnote-signature-container">
					<img
						src={`${process.env.PUBLIC_URL}/assets/images/icons/powered-by-highnote-black-${sidebarImg}`}
						className="highnote-ai-img-sidebar"
					/>
				</div>
			</a>
		);
	}

	return (
		<a href={LINK} target="_blank">
			<div className="highnote-signature-container">
				<span className="highnote-signature-powered-text" style={{ color: "white" }}>
					Powered by
				</span>
				<div className="highnote-signature-logo-container">
					<object
						type="image/svg+xml"
						data={`${process.env.PUBLIC_URL}/assets/images/icons/highnote-icon.svg`}
						className="highnote-signature-logo"
					>
						<img src={`${process.env.PUBLIC_URL}/assets/images/icons/highnote-icon.svg`} />
					</object>
				</div>

				<img src={`${process.env.PUBLIC_URL}/assets/images/icons/highnote-ai.svg`} className="highnote-ai-img" />
			</div>
		</a>
	);
};

export default HighnoteSignature;
